module.exports = __webpack_public_path__ + "img/text.31227ea1.svg";